import { render, staticRenderFns } from "./PriceTableDisplay.vue?vue&type=template&id=4535e77d&scoped=true&"
import script from "./PriceTableDisplay.vue?vue&type=script&lang=js&"
export * from "./PriceTableDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4535e77d",
  null
  
)

export default component.exports